import React from "react";
import {
  Home,
  DashboardCustomizeOutlined,
  AccessTime,
  Groups2Outlined,
  Business,
  AssignmentOutlined,
  AssessmentOutlined,
  DockOutlined,
  RequestQuoteOutlined,
  CalendarMonthRounded,
  CakeOutlined,
  MessageOutlined,
  CelebrationOutlined,
  FormatQuoteOutlined,
  VerifiedOutlined,
  CancelOutlined,
  PendingActionsOutlined,
  HourglassBottomOutlined,
  AccountTreeOutlined,
  ShowChartOutlined,
  SettingsOutlined,
  Approval
  
} from "@mui/icons-material";
import {
  HomeIcon,
  UsersIcon,
  FolderIcon,
  CalendarIcon,
  LogoutIcon,
  DocumentIcon,
  BriefcaseIcon,
  ClipboardListIcon,
  ArrowSmRightIcon,
} from "@heroicons/react/outline";
import { UserCog } from "lucide-react"
 

export const typeOfApplication ="ADMIN";
export const menu = [
  {
    id: 1,
    title: "Employee",
    children: [
      { id: 2, title: "Manage Employee", path: "/manageemployee" },
      { id: 3, title: "Add Project", path: "/addproject" },
      { id: 4, title: "Add Employee Status", path: "/addemployeestatus" },
      { id: 5, title: "Update Project", path: "/updateproject" },
      { id: 6, title: "View Invoices", path: "/viewinvoices" },
    ],
  },
  {
    id: 7,
    title: "Client",
    children: [{ id: 8, title: "Add Client", path: "/addclient" }],
  },
  {
    id: 9,
    title: "Employee Profile",
    children: [{ id: 10, title: "EmployeeProfile", path: "/profile" }],
  },
  {
    id: 11,
    title: "Reports",
    children: [
      { id: 12, title: "Timesheet", path: "/timesheet" },
      { id: 13, title: "Projects", path: "/projects" },
      { id: 14, title: "Budget", path: "/budget" },
    ],
  },
];

export const statusOptions = [
  { label: "CPT", value: "CPT" },
  { label: "OPT", value: "OPT" },
  { label: "H1", value: "H1" },
  { label: "H4", value: "H4" },
  { label: "EAD", value: "EAD" },
  { label: "Green Card", value: "Green Card" },
  { label: "Citizen", value: "Citizen" },
];

export const userTypeFilterOptions = [
  {label: "ADMIN", value: "ADMIN"},
  {label: "USER", value: "USER"},
  {label: "ALL", value: "ALL"},
];

export const statusFilterOptions = [
  {label:"ACTIVE", value:"A"},
  {label: "DEACTIVE", value: "D"},
  {label: "ALL", value: "ALL"},
]

export const AdminNavigation = [
  {
    name: "Dashboard",
    icon: DashboardCustomizeOutlined,
    href: "/",
    children: false,
    access: ["ADMIN", "Admin", "USER"]
  },
  {
    name: "Employee",
    icon: Groups2Outlined,
    children: false,
    href: "/manageemployee",
    access: ["ADMIN", "Admin"],
  },
  {
    name: "Events",
    icon: CalendarMonthRounded,
    children: true,
    href: "/events",
    access: ["ADMIN", "Admin"],
    items: [
      { 
        name: "Birthdays", 
        href: "/birthdays", 
        icon: CakeOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "Anniversaries", 
        href: "/anniversaries", 
        icon: CelebrationOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "Quotes", 
        href: "/quotes", 
        icon: FormatQuoteOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
    ],
  },
  {
    name: "Timesheet",
    icon: AccessTime,
    children: true,
    href: "/timesheets",
    access: ["ADMIN", "Admin"],
    items: [
      { 
        name: "To Be Approved", 
        href: "/pendingTimesheets", 
        icon: VerifiedOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "Rejected", 
        href: "/rejectedTimesheets", 
        icon: CancelOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "To Be Invoiced", 
        href: "/tobeinvoiced", 
        icon: PendingActionsOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
    ],
  },
  {
    name: "Time Off",
    icon: Approval,
    href: "/timeoff",
    access: ["ADMIN", "Admin"],
    children: true,
    items: [
      { 
        name: "Approved", 
        href: "/approvedtimeoff", 
        icon: VerifiedOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "Rejected Requests", 
        href: "/rejectedtimeoff", 
        icon: CancelOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
    ],
  },
  {
    name: "Invoices",
    icon: RequestQuoteOutlined,
    children: true,
    href: "/invoices",
    access: ["ADMIN", "Admin"],
    items: [
      { 
        name: "Payment Pending", 
        href: "/pendingInvoices", 
        icon: HourglassBottomOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
    ],
  },
  { 
    name: "Client", 
    icon: Business, 
    href: "/addclient", 
    children: false, 
    access: ["ADMIN", "Admin"] 
  },
  {
    name: "Project",
    icon: AssignmentOutlined,
    href: "/addproject",
    children: false,
    access: ["ADMIN", "Admin"]
  },
  {
    name:"Admin Preferences",
    access:["ADMIN", "Admin"],
    icon: UserCog,
    children: false,
    href:"/adminPreferences"
  },
  {
    name: "Reports",
    icon: AssessmentOutlined,
    children: true,
    href: "/reports",
    access: ["ADMIN", "Admin"],
    items: [
      { 
        name: "Projects", 
        href: "/projects", 
        icon: AccountTreeOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
      { 
        name: "Budget", 
        href: "/budget", 
        icon: ShowChartOutlined, 
        access: ["ADMIN", "Admin"],
        isChild: true 
      },
    ],
  },
  {
    name: "TimeSheets",
    icon: AccessTime,
    href: "/emptimesheets",
    access: ["USER"],
    children: false,
  },

  {
    name: "Documents",
    icon: DockOutlined,
    href: "/documents",
    access: ["USER"],
    children: false,
  },
];

export const EmpNavigation = [
  { name: "Dashboard", icon: HomeIcon, href: "/", children: false },
  {
    name: "Documents",
    icon: DocumentIcon,
    href: "/documents",
    children: false,
  },
];

export const  primaryColor = "#155e75";

export const monthsData = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" }, 
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" },    
];